// Simulated maintenance data for the MHI-J1, a fictional twin-engine jet.
// Illustrative demo values only; not taken from any real aircraft type.
// Fault ids follow the ATA chapter-section-subject pattern (e.g. 73-21-04).

export const aircraftStatus = {
  designation: 'MHI-J1',
  tail: 'DEMO-01',
  status: 'On ground · maintenance',
  location: 'Maintenance hangar 2',
  airframeHours: 1284.6,
  cycles: 912,
  engines: {
    left: { egtLastRunC: 742, egtMarginC: 38, oilQtyPct: 92, vibrationIps: 0.21, hours: 1102.3 },
    right: { egtLastRunC: 768, egtMarginC: 12, oilQtyPct: 88, vibrationIps: 0.34, hours: 1098.7 },
  },
  hydraulics: {
    systemA: { pressurePsi: 3000, fluidPct: 96 },
    systemB: { pressurePsi: 2710, fluidPct: 81 },
  },
  fuel: { totalKg: 4820, capacityKg: 8200, imbalanceKg: 140 },
  landingGear: {
    nose: { tyrePsi: 185, brakeTempC: 38 },
    left: { tyrePsi: 205, brakeTempC: 61 },
    right: { tyrePsi: 203, brakeTempC: 142 },
  },
  cockpit: { seatPins: 'Installed', canopySeal: 'Normal', oxygenPct: 94, avionicsBit: 'Pass' },
  electrical: { batteryV: 27.4, generators: 'Offline (ground power)' },
};

export const aircraftFaults = [
  {
    id: '32-42-01',
    ata: '32',
    severity: 'critical',
    status: 'active',
    category: 'landing gear',
    title: 'Brake overtemperature, right main gear',
    description: 'Right main brake at 142 °C, 81 °C above the left brake after taxi-in.',
    recommendation: 'Keep clear of the wheel. Inspect for a dragging brake once below 80 °C.',
    affectedComponent: 'Right main landing gear',
  },
  {
    id: '73-21-04',
    ata: '73',
    severity: 'warning',
    status: 'active',
    category: 'powerplant',
    title: 'EGT thermocouple spread, right engine',
    description: 'Harness B reads 26 °C above harness A at idle. EGT margin down to 12 °C.',
    recommendation: 'Inspect harness B connector, then confirm on a ground run.',
    affectedComponent: 'Right engine turbine section',
  },
  {
    id: '29-11-02',
    ata: '29',
    severity: 'warning',
    status: 'active',
    category: 'hydraulics',
    title: 'Hydraulic system B low pressure',
    description: 'System B at 2,710 psi against 3,000 psi nominal; reservoir at 81 %.',
    recommendation: 'Check reservoir level and look for external leaks before servicing.',
    affectedComponent: 'Hydraulic system B reservoir',
  },
  {
    id: '28-41-07',
    ata: '28',
    severity: 'info',
    status: 'active',
    category: 'fuel',
    title: 'Fuel quantity imbalance',
    description: 'Left and right wing tanks differ by 140 kg.',
    recommendation: 'Monitor. Balance on the next refuel.',
    affectedComponent: 'Wing fuel tanks',
  },
  {
    id: '34-10-03',
    ata: '34',
    severity: 'info',
    status: 'resolved',
    category: 'avionics',
    title: 'Air data computer self-test retry',
    description: 'Self-test passed on the second attempt.',
    recommendation: 'No action. Record in the technical log.',
    affectedComponent: 'Avionics bay',
  },
];

/** Aircraft counterpart of the EV high-voltage protocol. */
export const aviationSafetySteps = [
  'Aircraft chocked and grounded',
  'Landing-gear and ejection-seat safety pins installed',
  'Hydraulic and electrical power off and tagged',
  'Intake and exhaust covers fitted, FOD walk completed',
];

export default aircraftStatus;
